// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"490":"4157740c","787":"5c995620"}[chunkId] + ".chunk.js";
};